/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type ProductDeleteInput = {
    id: string;
    clientMutationId?: string | null;
};
export type ProductDeleteMutationVariables = {
    input: ProductDeleteInput;
};
export type ProductDeleteMutationResponse = {
    readonly productDelete: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ProductDeleteMutation = {
    readonly response: ProductDeleteMutationResponse;
    readonly variables: ProductDeleteMutationVariables;
};



/*
mutation ProductDeleteMutation(
  $input: ProductDeleteInput!
) {
  productDelete(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ProductDeletePayload",
    "kind": "LinkedField",
    "name": "productDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e7950cc97c63b64a6a4d750ec288f470",
    "id": null,
    "metadata": {},
    "name": "ProductDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation ProductDeleteMutation(\n  $input: ProductDeleteInput!\n) {\n  productDelete(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'cc4173f0c1c4ecb7812e8d2a1a2c167b';
export default node;
